import { createStrings } from '@utils/local';
import type { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '過去の案件',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 5,
  staffOnly: true,
};
